<template>
  <div class="showcase-container">
    <FilledBanner
      :title="$t('精选客户实践案例')"
      :subtitle="$t('了解全球同行如何使用DG.hire成功管理海外团队')"
      bg-image="https://video.reta-inc.com/image/default/3373C26E46E247459AB89225F64D0C7E-6-2.jpg"
    />
    <div class="content">
      <div class="tabs">
        <NuxtLink
          v-for="(tab, i) in showcaseList"
          :key="tab.tabName"
          class="item-tab"
          :class="{ active: current === tab.routeName }"
          :href="`/showcase/${tab.routeName}`"
          @click="current = tab.routeName"
        >
          {{ $t(tab.tabName) }}
        </NuxtLink>
      </div>
      <div
        v-for="(showcase, i) in showcaseList"
        :key="showcase.tabName"
        v-show="current === showcase.routeName"
        class="tab-content"
      >
        <h3 class="title">{{ $t(showcase.title) }}</h3>
        <figure class="figure">
          <div class="figure-img" :style="{ backgroundImage: `url(${showcase.img})` }"></div>
          <div>
            <figcaption>{{ $t('客户故事') }}</figcaption>
            <div class="story-desc">{{ $t(showcase.storyDesc) }}</div>
          </div>
        </figure>
        <div v-if="showcase.solution" class="solution">
          <div class="solution-title">& {{ $t('解决方案') }}</div>
          <div class="solution-content">{{ $t(showcase.solution) }}</div>
        </div>
        <div class="sub-content" :style="{ marginTop: showcase.solution ? '120px' : '80px' }">
          <div class="sub-title">{{ $t('他们喜欢使用哪些功能？') }}</div>
          <div class="fun-list">
            <div v-for="(fun, i) in showcase.funList" :key="i" class="fun-item">
              <div class="nav">
                <div class="fun-title">{{ $t(fun.funTitle) }}</div>
                <a-rate class="fun-star" :default-value="fun.star" readonly />
              </div>
              <ul class="fun-content">
                <li v-for="fc in fun.funDescList" :key="fc" class="fc">{{ $t(fc) }}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <RecommendForYou />
  </div>
</template>

<script setup lang="ts">
import showcaseList from '@/assets/contents/showcase.json';
import { onMounted } from 'vue';
const moduleName = useState('module-name');
moduleName.value = 'showcase';

const current = ref('new-energy');
const route = useRoute();

onMounted(() => {
  current.value = route.params.id as string;
});

useSeoHead();
</script>

<style lang="less" scoped>
.showcase-container {

  .content {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    width: 1280px;
    padding: 0 32px;
    margin-bottom: 100px;

    .tabs {
      width: 100%;
      height: 120px;
      padding: 0 100px;
      box-sizing: border-box;
      background: #ffffff;
      box-shadow: 0px 4px 32px rgba(135, 172, 255, 0.2);
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: -40px;

      .item-tab {
        // width: 162px;
        padding: 0 40px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        border-radius: 12px;
        font-weight: 400;
        font-size: 20px;
        line-height: 28px;
        color: #4e5969;
        cursor: pointer;
        text-decoration: none;

        &.active {
          background-color: #fff;
          background: rgba(22, 93, 255, 0.1);
          font-weight: 500;
          color: #386aff;
        }

        &:hover {
          color: #386aff;
        }
      }
    }

    .tab-content {
      .title {
        font-weight: 600;
        font-size: 40px;
        line-height: 56px;
        color: #1d2129;
        margin: 60px 0 0 0;
        padding-bottom: 24px;
        border-bottom: 1px solid #e5e7eb;
      }

      .figure {
        margin: 48px 0 0;
        display: flex;
        gap: 80px;

        .figure-img {
          width: 560px;
          height: 340px;
          background-repeat: no-repeat;
          background-size: 560px 340px;
          flex-shrink: 0;
          border-radius: 12px;
        }

        figcaption {
          font-weight: 500;
          font-size: 26px;
          line-height: 36px;
          color: #1d2129;
          margin-bottom: 40px;
        }

        .story-desc {
          font-weight: 400;
          font-size: 18px;
          line-height: 36px;
          color: #4e5969;
        }
      }

      .solution {
        margin-top: 80px;
        padding: 32px 40px;
        background: url(https://video.reta-inc.com/image/default/B1BC1B6BD7A243F28BBDEC7C3EBEE18B-6-2.png) no-repeat
          center center/100% auto;
        border-radius: 12px;

        .solution-title {
          font-weight: 500;
          font-size: 26px;
          line-height: 36px;
          color: #1d2129;
          margin-bottom: 32px;
        }

        .solution-content {
          font-weight: 400;
          font-size: 18px;
          line-height: 36px;
          color: #4e5969;
        }
      }
    }

    .sub-content {
      .sub-title {
        font-weight: 500;
        font-size: 26px;
        line-height: 36px;
        color: #000000;
        padding-left: 50px;
        background: url('@/assets/icons/sub-title.svg') no-repeat left center/30px 30px;
        margin-bottom: 40px;
      }

      .fun-list {
        display: flex;
        gap: 80px;

        .fun-item {
          flex: 1;
          background: #f0f5ff;
          border-radius: 12px;

          .nav {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 19px 32px;

            .fun-title {
              font-weight: 500;
              font-size: 24px;
              line-height: 34px;
              color: #1d2129;
            }
          }

          .fun-content {
            background: #ffffff;
            border: 1px solid #165dff;
            border-radius: 12px;
            padding: 32px 20px 32px 40px;
            // height: 136px;
            box-sizing: border-box;
            margin: 0;

            .fc {
              font-weight: 400;
              font-size: 20px;
              line-height: 36px;
              color: #1d2129;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 800px) {
  .showcase-container {
    padding-bottom: 40px;

    .content {
      width: 100%;
      padding: 0;

      .tabs {
        margin-top: 0;
        padding: 0;
        height: 56px;
        justify-content: space-around;
        box-shadow: 0px 4px 4px rgba(135, 172, 255, 0.1);
        position: sticky;
        top: 108px;
        border-radius: 0;

        .item-tab {
          width: 81px;
          height: 40px;
          border-radius: 6px;
          font-size: 14px;
          text-decoration: none;
        }
      }

      .tab-content {
        padding: 0 16px;
        box-sizing: border-box;

        .title {
          font-size: 18px;
          line-height: 25px;
          margin-top: 24px;
          padding-bottom: 16px;
        }

        .figure {
          flex-wrap: wrap;
          margin-top: 16px;
          gap: 24px;

          .figure-img {
            width: 100%;
            height: auto;
            background-size: 100% 100%;
            aspect-ratio: 343 / 198;
          }

          figcaption {
            margin-bottom: 12px;
            font-size: 16px;
            line-height: 22px;
          }

          .story-desc {
            font-size: 13px;
            line-height: 24px;
          }
        }

        .solution {
          margin-top: 24px;
          padding: 16px 16px;
          background-size: cover;

          .solution-title {
            font-size: 16px;
            line-height: 22px;
            margin-bottom: 12px;
          }

          .solution-content {
            font-size: 13px;
            line-height: 24px;
          }
        }

        .sub-content {
          margin-top: 32px !important;

          .sub-title {
            font-size: 16px;
            line-height: 22px;
            background-size: 16px 16px;
            padding-left: 28px;
            margin-bottom: 20px;
          }

          .fun-list {
            flex-direction: column;
            gap: 20px;

            .fun-item {
              .nav {
                padding: 12px 16px;

                .fun-title {
                  font-size: 14px;
                  line-height: 20px;
                }

                .fun-star {
                  font-size: 16px;
                }
              }

              .fun-content {
                padding: 12px 7px 12px 34px;
                height: 100%;
                // height: 80px;

                .fc {
                  font-size: 14px;
                  line-height: 28px;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
